
<template>
        <div class="mt-4">
            <Programs/>
        </div>
</template>
<script>
import Programs from "@/modules/ulmerCertificatesApplicationForm/components/Programs.vue";
export default {
    name: "PersonelInformation",
    components: {Programs},
    data(){
        return {
            programs:[]
        }
    },
}
</script>


<style scoped>

</style>
